import { Button, List, Text } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Container from "../Container";

type Props = {
	onPrimaryPress: () => void;
	onSecondaryPress?: () => void;
	primaryActionLabel: string;
	secondaryActionLabel?: string;
	selectedItemText?: string;
	selectedItemLabel?: string;
	disabled?: boolean;
	disabledSecondary?: boolean;
};

const BottomAppBar = ({
	onPrimaryPress,
	onSecondaryPress,
	primaryActionLabel,
	secondaryActionLabel,
	selectedItemText,
	selectedItemLabel,
	disabled = false,
	disabledSecondary = false,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const insets = useSafeAreaInsets();
	return (
		<Container
			containerStyle={{
				paddingBottom: 16 + insets.bottom,
				paddingHorizontal: isMobile ? 16 : 0,
			}}
			autoSize
			maxWidth="xs"
		>
			{selectedItemText && (
				<Box paddingVertical={16} gap={8}>
					<Text
						variant="titleSmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{selectedItemLabel}
					</Text>
					<List.Item
						title={selectedItemText}
						left={(props) => <List.Icon {...props} icon="check" />}
						style={{
							paddingVertical: 0,
							backgroundColor: theme.colors.elevation.level1,
						}}
						titleStyle={{ color: theme.colors.onSurface }}
					/>
				</Box>
			)}
			<Box width="100%" gap={8}>
				<Button mode="contained" onPress={onPrimaryPress} disabled={disabled}>
					{primaryActionLabel}
				</Button>
				{onSecondaryPress && (
					<Button
						mode="text"
						onPress={onSecondaryPress}
						disabled={disabledSecondary}
					>
						{secondaryActionLabel}
					</Button>
				)}
			</Box>
		</Container>
	);
};

export default BottomAppBar;
